import { useTranslation } from "react-i18next";
import { EmailIcon, FacebookIcon, InstagramIcon, LocationIcon, PinterestIcon, TwitterIcon, WhatsappIcon } from "../../assets/images/icons/socialMedia";
import { whiteTextLogo } from "../../assets/images/logos";

export default function Footer() {
  const { t } = useTranslation();
  const socialLinks = [
    {
      link: "https://www.facebook.com/",
      icon: <FacebookIcon />
    },
    {
      link: "https://www.instagram.com/thunder_streetwear_maroc?igsh=MW1kbnFpOXNyZHg0eQ==",
      icon: <InstagramIcon />
    },
    {
      link: "https://www.pinterest.com/",
      icon: <PinterestIcon />
    },
    {
      link: "https://wa.me/905359245987",
      icon: <WhatsappIcon />
    },
  ];

  const footerLinks = [
    {
      main: "product-categories",
      other: ["category-carousel.sweatshirts", "category-carousel.tracksuits", "category-carousel.jackets", "category-carousel.jeans", "category-carousel.shirts", "category-carousel.jerseys", "category-carousel.accessories"]
    },
    {
      main: "customer-service.item1",
      other: ["customer-service.item2", "customer-service.item3", "customer-service.item4", "customer-service.item5"]
    },
    {
      main: "about-us.item1",
      other: ["about-us.item2", "about-us.item3", "about-us.item4", "about-us.item5",]
    },
  ];

  const infoLinks = [
    {
      text: "Casablanca, Morocco",
      icon: <LocationIcon />
    },
    {
      text: "thundermaroc2025@gmail.com",
      icon: <EmailIcon />
    },
  ];

  return (
    <footer className="bg-black text-white pt-5">
      <div className="flex-col lg:flex px-4 pt-4 pb-3 md:px-10">
        {/* TOP CONTAINER */}
        <div className="lg:flex lg:flex-row lg:justify-between">
          {/* LOGO DIV */}
          <div>
            {/* LOGO */}
            <img loading="lazy"  src={whiteTextLogo} className="w-36 h-auto" alt="logo" />
            <p className="mt-4 max-w-80 text-base font-light text-gray-300">
              {t("logo-footer-text")}
            </p>
            {/* SOCIAL MEDIA ICONS */}
            <div className="mb-8 mt-6 flex flex-row gap-4">
              {socialLinks.map((item, index) => (
                <a key={index} href={item.link} target="_blank" rel="noopener noreferrer" className="mr-4">
                {item.icon}
              </a>              
              ))}
            </div>
          </div>
          {/* FOOTER LINKS */}
          <div className="flex grow flex-row flex-wrap lg:mx-10 lg:flex-nowrap lg:justify-center">
            {/* LINK BLOCK */}
            {footerLinks.map((item, index) => (
              <div key={index} className="my-5 mr-8 flex max-w-52 grow basis-24 flex-col space-y-2 lg:mx-10 lg:mt-0">
                <h2 className="font-semibold text-sm text-white uppercase">{t(item.main)}</h2>
                {item.other.map((item, index) => (
                  <a key={index} href="/#_" className="text-sm text-gray-300">
                    {t(item)}
                  </a>
                ))}
              </div>
            ))}
          </div>
          {/* LOCATION & SUPPORT */}
          <div className="mt-10 flex flex-col lg:mt-0">
            {infoLinks.map((item, index) => (
              <div key={index} className="mb-2 flex flex-row items-center max-w-72">
                {item.icon}
                <p className="ml-4 text-gray-300 text-sm">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
        <p className="border-t border-gray-300 pt-3 text-center text-sm text-gray-300 lg:mt-0">{t("copyright")}</p>
      </div>
    </footer>
  )
}
